import { toast, ToastOptions } from "react-toastify";
import ConfirmToast from "../../components/forms/notification/Confirm";

export interface NotifyOptions extends ToastOptions {}

export interface ConfirmOptions {
  message: string;
  onConfirm: () => void;
  title?: string;
  type?: string;
  autoClose?: number | false;
  closeOnConfirm?: boolean;
  onClose?: () => void;
}

export const notify = {
  show(message: string, options?: NotifyOptions) {
    return toast(message, options);
  },

  success(message: string, options?: NotifyOptions) {
    return toast.success(message, options);
  },

  error(message: string, options?: NotifyOptions) {
    return toast.error(message, options);
  },

  warning(message: string, options?: NotifyOptions) {
    return toast.warning(message, options);
  },

  info(message: string, options?: NotifyOptions) {
    return toast.info(message, options);
  },

  confirm(options: ConfirmOptions) {
    const {
      message,
      onConfirm,
      title = "OK",
      type = "del",
      autoClose = 3000,
      closeOnConfirm = true,
      onClose,
    } = options;

    return toast(
      <ConfirmToast
        message={message}
        onConfirm={onConfirm}
        type={type}
        title={title}
        closeOnConfirm={closeOnConfirm}
      />,
      {
        progressClassName: "toast-progress-delete",
        autoClose,
        onClose,
      },
    );
  },

  dismiss(toastId?: string | number) {
    if (toastId !== undefined) {
      toast.dismiss(toastId);
    } else {
      toast.dismiss();
    }
  },
};

export default notify;
